/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 28.11.13, 17:05
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */


export class AgeGateValidationVO {
    // Value to validate
    public age: number;

    // Triggered when validation has been finished
    public onValidationFinished: Function;

    constructor(age: number, onValidationFinished: Function) {
        this.age = age;
        this.onValidationFinished = onValidationFinished;
    }
}
